const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

export default delay
